import React from "react";
import Navigation from "../../organisms/Navigation/Navigation";
import Footer from "../../organisms/Footer/Footer";
import FaqBody from "../../molecules/FAQBody/Faqbody";
const Faq = () => {
  return (
    <div>
      <Navigation />
      <FaqBody />
      <Footer />
    </div>
  );
};

export default Faq;
